export const isMostlyGreen = (r: number, g: number, b: number) => {
  return (
    g > 0 && // enough green
    g > r + 0 && // more green than red
    g > b + 10 // more green than blue
  );
};
